import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'bachl',
} as IModuleProps;
